type MobilePlatform = 'ios' | 'android' | 'other';

interface NavigatorUAData {
  mobile: boolean;
  platform: string;
}

const hasUserAgentData = (): boolean => 'userAgentData' in navigator;

const getUserAgentData = (): NavigatorUAData | null => {
  if (hasUserAgentData()) {
    return (navigator as Navigator & { userAgentData: NavigatorUAData }).userAgentData;
  }
  return null;
};

const isTablet = (): boolean => {
  const ua = navigator.userAgent;
  const isIPhoneOrIPod = /iPhone|iPod/i.test(ua);
  const isIPad =
    /iPad/i.test(ua) || (!isIPhoneOrIPod && /Macintosh|MacIntel/i.test(ua) && navigator.maxTouchPoints > 1);
  const isAndroidTablet = /Android/i.test(ua) && !/Mobile/i.test(ua);
  return isIPad || isAndroidTablet;
};

const isMobileDevice = (): boolean => {
  if (isTablet()) {
    return false;
  }

  const uaData = getUserAgentData();
  if (uaData !== null) {
    return uaData.mobile;
  }

  const ua = navigator.userAgent;
  return /Android.*Mobile|iPhone|iPod|Windows Phone|webOS|BlackBerry|Opera Mini|IEMobile/i.test(ua);
};

const getMobilePlatform = (): MobilePlatform => {
  const uaData = getUserAgentData();
  const platform = uaData?.platform?.toLowerCase() ?? '';

  if (platform === 'ios' || /iPhone|iPod|iPad/i.test(navigator.userAgent)) {
    return 'ios';
  }

  if (platform === 'android' || /Android/i.test(navigator.userAgent)) {
    return 'android';
  }

  return 'other';
};

export const DeviceDetectionUtils = {
  isMobileDevice,
  getMobilePlatform,
};
